<template>
  <router-link :to="href" class="culture-card">
    <v-img v-if="showImage" :src="[image, fallbackImage] | mediaSrc" :alt="image ? title : ''" aspect-ratio="1.55" class="culture-card-image" gradient="to bottom, rgba(0,0,0,.01), rgba(0,0,0,.2)">
      <span v-if="badge" class="culture-card-badge">{{ badge }}</span>
    </v-img>
    <div class="culture-card-copy">
      <p v-if="eyebrow" class="culture-card-eyebrow">{{ eyebrow }}</p>
      <h3>{{ title }}</h3>
      <ul v-if="metadata.length" aria-label="Quick facts">
        <li v-for="(item, index) in metadata" :key="`${item}-${index}`">{{ item }}</li>
      </ul>
      <div v-if="visibleMatchLabels.length" class="culture-card-matches">
        <p>Matched Tags</p>
        <ul aria-label="Matched tags">
          <li v-for="label in visibleMatchLabels" :key="label">{{ label }}</li>
          <li v-if="hiddenMatchLabelCount">+{{ hiddenMatchLabelCount }}</li>
        </ul>
      </div>
      <p v-if="summary" class="culture-card-summary">{{ summary }}</p>
      <strong>Explore <v-icon small>mdi-arrow-right</v-icon></strong>
    </div>
  </router-link>
</template>

<script>
import { mediaRef } from '@/services/mediaAssets';

const fallbackImage = mediaRef('adventures/the-reckon-way-hero.png');

export default {
  name: 'CultureCard',
  props: {
    title: { type: String, required: true },
    href: { type: [String, Object], required: true },
    image: { type: [String, Object], default: '' },
    eyebrow: { type: String, default: '' },
    summary: { type: String, default: '' },
    metadata: { type: Array, default: () => [] },
    badge: { type: String, default: '' },
    showImage: { type: Boolean, default: true },
    matchLabels: { type: Array, default: () => [] },
  },
  data: () => ({ fallbackImage }),
  computed: {
    visibleMatchLabels() {
      return this.matchLabels.slice(0, 3);
    },
    hiddenMatchLabelCount() {
      return Math.max(this.matchLabels.length - this.visibleMatchLabels.length, 0);
    },
  },
};
</script>

<style scoped>
.culture-card { background: #131313; border: 1px solid #2d2d2d; border-radius: 12px; color: inherit; display: block; height: 100%; overflow: hidden; text-decoration: none; transition: border-color 180ms ease, transform 180ms ease; }
.culture-card:hover, .culture-card:focus { border-color: #e23232; transform: translateY(-4px); }
.culture-card-image { background: #090909; overflow: hidden; position: relative; }
.culture-card-image::v-deep .v-image__image { transform: scale(1.02); }
.culture-card-badge { background: #e23232; border-radius: 999px; color: #fff; font-size: .72rem; font-weight: 900; left: 14px; padding: 6px 10px; position: absolute; text-transform: uppercase; top: 14px; }
.culture-card-copy { padding: 22px; }
.culture-card-eyebrow { color: #f0b13c; font-family: "Oswald", sans-serif; font-size: .78rem; font-weight: 800; margin: 0 0 6px; text-transform: uppercase; }
h3 { color: #fff; font-family: "Oswald", sans-serif; font-size: 1.55rem; margin: 0 0 12px; }
ul { display: flex; flex-wrap: wrap; gap: 6px; list-style: none; margin: 0 0 14px; padding: 0; }
li { border: 1px solid #3b3b3b; border-radius: 999px; color: #bdbdbd; font-size: .75rem; padding: 4px 8px; }
.culture-card-matches { margin: 0 0 14px; }
.culture-card-matches p { color: #e83b3b; font-family: "Oswald", sans-serif; font-size: .68rem; font-weight: 900; margin: 0 0 6px; text-transform: uppercase; }
.culture-card-matches ul { margin: 0; }
.culture-card-matches li { border-color: rgba(232, 59, 59, .65); color: #eee; }
.culture-card-summary { color: #bdbdbd; line-height: 1.55; margin: 0 0 18px; }
strong { color: #fff; font-size: .82rem; text-transform: uppercase; }
strong .v-icon { color: #e23232; }
</style>
